import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { LocaleProvider, message } from 'antd'
import enUS from 'antd/lib/locale-provider/en_US'

import reducers from './Reducers'
import AppRouter from './router'
import './index.scss'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(reducers, composeEnhancers(
    applyMiddleware(thunkMiddleware)
))

message.config({
  duration: 3
})

ReactDOM.render(
    <Provider store={store}>
		<LocaleProvider locale={enUS}>
	    	<AppRouter/>
		</LocaleProvider>
	</Provider>, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js